// extracted by mini-css-extract-plugin
export default {"list":"wwObTMF","list__animate":"XwEa996","carouselLink":"qtSpniD TYb4J9A"};